import React from 'react';
import LandingNav from './LandingNav';
import LandingFooter from './LandingFooter';
import SeoMeta from '../SeoMeta';
import './LandingPage.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="landing-page">
      <SeoMeta
        title="Privacy Policy — Map of Projects"
        description="Privacy policy for Map of Projects."
        path="/privacy"
      />
      <a href="#main-content" className="landing-skip-link">Skip to content</a>
      <LandingNav />

      <main id="main-content">
        <section className="legal-content">
          <p className="legal-content__eyebrow">Legal</p>
          <h1>Privacy Policy</h1>
          <p className="legal-content__meta">Last updated: [DATE]</p>

          <p>[PLACEHOLDER — paste Privacy Policy text here.]</p>
        </section>
      </main>

      <LandingFooter />
    </div>
  );
};

export default PrivacyPolicy;
